import * as React from 'react'
import { SVGProps } from 'react'
const SvgBagThin = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 17 21" xmlSpace="preserve" {...props}>
    <path d="M15.5 4.5h-3.3c-.4-1.8-1.4-4-3.7-4-2.3 0-3.3 2.2-3.7 4H1.5l-1.1 16h16.1l-1-16zm-7-3c1.6 0 2.3 1.5 2.7 3H5.8c.4-1.5 1.1-3 2.7-3zm-7 18 .9-14h2.1v2h1V7s0-.7.1-1.5h5.7c.2.8.2 1.5.2 1.5v.5h1V7c0-.1 0-.7-.1-1.5h2.1l.9 14H1.5z" />
  </svg>
)
export default SvgBagThin
